import React from 'react';
import { IAttendeeUpdateBulkJobDetails, IAttendeeUpdateBulkJobResult } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { AlertErrorMessage } from '../../global/modal/alerts-host/types/alert/alert-error-message';

const attendeesUpdateBulkJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IAttendeeUpdateBulkJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IAttendeeUpdateBulkJobDetails, IAttendeeUpdateBulkJobResult>) => {
        return <div>{!!props.result?.sendRegistrationEmail
            ? 'Attendee status updates complete, emails have been sent to updated Attendees'
            : 'Attendee status updates complete'
        }
        </div>;
    },
    failedComponent: (props: IJobResultComponentProps<IAttendeeUpdateBulkJobDetails, IAttendeeUpdateBulkJobResult>) => {
        return <AlertErrorMessage title='Update Failed' message={props.result?.failureReason || 'Unknown failure reason'} />;
    },
};

export { attendeesUpdateBulkJobProperties };
